import { Injectable } from '@angular/core';
import {
  LoadingController,
  ToastController,
} from '@ionic/angular';

@Injectable({
  providedIn: 'root',
})
export class ToasterService {
  // map semantic types / common color names to Ionic color tokens
  private colorMap: { [key: string]: string } = {
    success: 'success',
    ok: 'success',
    error: 'danger',
    danger: 'danger',
    warn: 'warning',
    warning: 'warning',
    info: 'primary',
    red: 'danger',
    yellow: 'warning',
    green: 'success',
  };

  // allowed raw ionic color tokens (fallback if user passes a valid token)
  private allowedIonicColors = [
    'primary',
    'secondary',
    'tertiary',
    'success',
    'warning',
    'danger',
    'light',
    'medium',
    'dark',
  ];

  private resolveColor(type?: any): string {
    if (!type) {
      return 'primary';
    }
    const key = String(type).toLowerCase().trim();
    if (this.colorMap[key]) {
      return this.colorMap[key];
    }
    if (this.allowedIonicColors.includes(key)) {
      return key;
    }
    return 'primary';
  }

  constructor(
    private toastController: ToastController,
    public loadingController: LoadingController,
  ) {}

  async presentToast(type?: any, text?: any, duration = 2000) {
    const color = this.resolveColor(type);
    const toast = await this.toastController.create({
      color,
      message: text,
      duration,
    });
    await toast.present();
  }

  async presentError(type?: any, text?: any, duration = 2000) {
    // prefer explicit error/danger, but allow custom type mapping
    const color = this.resolveColor(type || 'error');
    const toast = await this.toastController.create({
      color,
      message: text,
      duration,
    });
    await toast.present();
  }

  // Show the loader for infinite time
  async showLoader() {
    const loading = await this.loadingController.create({
      message: 'Please wait...',
      spinner: 'crescent',
      showBackdrop: true,
    });

    await loading.present();
    return loading;
  }

  // Hide the loader if already created otherwise return error
  hideLoader() {
    this.loadingController
      .dismiss()
      .then((res) => {
        console.log('Loading dismissed!', res);
      })
      .catch((error) => {
        console.log('error', error);
      });
  }
}
